import { render } from "./StartupScreen.vue?vue&type=template&id=fb87c9e0&scoped=true"
import script from "./StartupScreen.vue?vue&type=script&lang=js"
export * from "./StartupScreen.vue?vue&type=script&lang=js"

import "./StartupScreen.vue?vue&type=style&index=0&id=fb87c9e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb87c9e0"]])

export default __exports__